import { render, staticRenderFns } from "./login-menu.vue?vue&type=template&id=2f08af18&scoped=true"
import script from "./login-menu.vue?vue&type=script&lang=js"
export * from "./login-menu.vue?vue&type=script&lang=js"
import style0 from "./login-menu.vue?vue&type=style&index=0&id=2f08af18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f08af18",
  null
  
)

export default component.exports